/* eg-oregano-research — click-to-switch benefit tabs.
   One tab is always open. The same state drives both layouts: the desktop
   card stage (crossfade) and the mobile fold under each tab; the motion itself
   is in CSS. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.egrsInit === 'true') return;
    root.dataset.egrsInit = 'true';

    var items = root.querySelectorAll('[data-egrs-item]');
    var tabs = root.querySelectorAll('[data-egrs-tab]');
    var panels = root.querySelectorAll('[data-egrs-panel]');

    function show(index) {
      for (var i = 0; i < items.length; i++) {
        var on = Number(items[i].getAttribute('data-egrs-item')) === index;
        items[i].classList.toggle('is-active', on);
      }
      for (var t = 0; t < tabs.length; t++) {
        tabs[t].setAttribute('aria-selected', String(Number(tabs[t].getAttribute('data-egrs-tab')) === index));
      }
      for (var p = 0; p < panels.length; p++) {
        var active = Number(panels[p].getAttribute('data-egrs-panel')) === index;
        panels[p].classList.toggle('is-active', active);
        if (active) panels[p].removeAttribute('aria-hidden');
        else panels[p].setAttribute('aria-hidden', 'true');
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function () {
        show(Number(this.getAttribute('data-egrs-tab')));
      });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-egrs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
